var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectManagementSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 145,
    height: 127.87,
    viewBox: "0 0 145 127.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "project_management_sm-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 145,
    height: 127.87,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_185",
    "data-name": "Groupe 185",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_184",
    "data-name": "Groupe 184",
    transform: "translate(0 0)",
    clipPath: "url(#project_management_sm-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_275",
    "data-name": "Trac\\xE9 275",
    d: "M105.9,26.379c19.475,26.425,24.309,53.86,1.534,70.578-23.048,16.916-72.58,22.037-88.108.32C2.064,73.146,10.787,28.691,32.244,12.042,55.209-5.779,86.718.356,105.9,26.379",
    transform: "translate(10.987 2.031)",
    fill: "#f7da9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_276",
    "data-name": "Trac\\xE9 276",
    d: "M55.07,67.22c-2.647-3.952-2.664-8.3,1.889-11.349,4.609-3.09,13.557-4.7,15.648-1.444,2.322,3.617-.587,10.919-4.9,13.94C63.081,71.6,57.677,71.111,55.07,67.22",
    transform: "translate(57.578 56.896)",
    fill: "#f7da9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_277",
    "data-name": "Trac\\xE9 277",
    d: "M86.939,7.067,56.726.283C45.672-1.35,41.186,9.46,39.552,20.514c0,0-4.67,14.367,9.01,20.657a62.262,62.262,0,0,1-10.4,8.392,1.1,1.1,0,0,0-.4,1.452,2.3,2.3,0,0,0,2.308,1.14,26.8,26.8,0,0,0,3.309-.333,42.924,42.924,0,0,0,6.551-1.459,75.255,75.255,0,0,0,12.454-5.209c.4-.206.791-.433,1.19-.643l23.279,3.442c11.054,1.634,15.513-6.863,17.147-17.917A20.231,20.231,0,0,0,86.939,7.067",
    transform: "translate(40.681 0.129)",
    fill: "#fdc728"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_278",
    "data-name": "Trac\\xE9 278",
    d: "M87.506,7.2,57.245.627A11.806,11.806,0,0,0,45.084,6.778c-2.5,4.21-3.6,9.133-4.272,14-2.293,7.687,1.092,16.516,8.746,19.592l1.29.658-.995,1.005a62.848,62.848,0,0,1-10.527,8.59c.316.668,1.038.547,2.133.433l2.549-.275c6.917-.98,13.472-3.8,19.652-7.036.316-.181.277-.164.622-.106,6.886,1.03,13.749,2.212,20.62,3.329,7.21,1.837,13.636-.106,16.7-7.333C108.1,25.916,103.6,10.255,87.506,7.2m0,0c16.208,2.78,20.9,18.828,14.829,32.762-3.049,7.783-9.9,10.161-17.648,8.471-6.9-.92-13.811-1.773-20.7-2.78l.622-.106c-6.338,3.425-13.06,6.4-20.264,7.518-2.152.046-3.769.968-6.037-.252-1.434-.841-1.694-3.28-.137-4.081.735-.466,1.463-.951,2.179-1.448A62.154,62.154,0,0,0,48.4,40.572l.3,1.663c-3.893-1.867-7.456-4.946-8.948-9.114a19.982,19.982,0,0,1-.329-12.581C40.741,13.389,42.866,4.8,49.858,1.12A12.34,12.34,0,0,1,57.341.2Z",
    transform: "translate(40.115 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_279",
    "data-name": "Trac\\xE9 279",
    d: "M73.457,9.449h0a2.694,2.694,0,0,0-3.769-.558L60.195,15.94a2.694,2.694,0,0,1-3.769-.556l-3.074-4.141a2.694,2.694,0,1,0-4.326,3.211l5.978,7.939a3.323,3.323,0,0,0,4.636.668L72.9,13.218a2.694,2.694,0,0,0,.558-3.769",
    transform: "translate(52.42 9.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_280",
    "data-name": "Trac\\xE9 280",
    d: "M60.551,108.47l-42.867,3.916a9.994,9.994,0,0,1-10.86-9.042L.042,29.1a9.994,9.994,0,0,1,9.042-10.86L51.95,14.328a9.994,9.994,0,0,1,10.86,9.042L69.592,97.61a9.993,9.993,0,0,1-9.042,10.86",
    transform: "translate(0 15.442)",
    fill: "#fdc728"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_281",
    "data-name": "Trac\\xE9 281",
    d: "M57,96.814l-43.06,3.933a4.516,4.516,0,0,1-4.909-4.085L2.718,27.582A4.514,4.514,0,0,1,6.8,22.675L49.865,18.74a4.515,4.515,0,0,1,4.907,4.087l6.311,69.08A4.517,4.517,0,0,1,57,96.814",
    transform: "translate(2.917 20.236)",
    fill: "#fff9ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_282",
    "data-name": "Trac\\xE9 282",
    d: "M45.043,27.034,7.462,30.468a1.6,1.6,0,0,1-.293-3.188L44.75,23.846a1.6,1.6,0,0,1,.293,3.188",
    transform: "translate(6.178 25.769)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_283",
    "data-name": "Trac\\xE9 283",
    d: "M36.848,30.689,15.662,32.625a1.6,1.6,0,1,1-.291-3.186L36.557,27.5a1.6,1.6,0,1,1,.291,3.186",
    transform: "translate(15.042 29.722)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_284",
    "data-name": "Trac\\xE9 284",
    d: "M17.221,31.926l-9.439.861A1.6,1.6,0,1,1,7.491,29.6l9.439-.864a1.6,1.6,0,1,1,.291,3.188",
    transform: "translate(6.524 31.057)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_285",
    "data-name": "Trac\\xE9 285",
    d: "M32.759,34.738,8.277,36.975a1.6,1.6,0,0,1-.291-3.188L32.468,31.55a1.6,1.6,0,1,1,.291,3.188",
    transform: "translate(7.061 34.096)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_286",
    "data-name": "Trac\\xE9 286",
    d: "M46.772,43.266,9.191,46.7A1.6,1.6,0,1,1,8.9,43.512l37.581-3.434a1.6,1.6,0,1,1,.291,3.188",
    transform: "translate(8.047 43.314)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_287",
    "data-name": "Trac\\xE9 287",
    d: "M38.577,46.922,17.391,48.858A1.6,1.6,0,1,1,17.1,45.67l21.186-1.935a1.6,1.6,0,0,1,.291,3.188",
    transform: "translate(16.911 47.266)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_288",
    "data-name": "Trac\\xE9 288",
    d: "M37.5,54.615,16.316,56.551a1.6,1.6,0,0,1-.291-3.188l21.186-1.935a1.6,1.6,0,0,1,.291,3.188",
    transform: "translate(15.749 55.582)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_289",
    "data-name": "Trac\\xE9 289",
    d: "M18.951,48.158l-9.439.861a1.6,1.6,0,1,1-.291-3.186l9.439-.864a1.6,1.6,0,0,1,.291,3.188",
    transform: "translate(8.394 48.602)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_290",
    "data-name": "Trac\\xE9 290",
    d: "M30.522,16.047l-5.007.483c.015-.162.05-.318.05-.483a5.493,5.493,0,0,0-10.985,0,5.41,5.41,0,0,0,.239,1.511l-4.191.4a1.615,1.615,0,0,0-1.615,1.615V24.11a1.614,1.614,0,0,0,1.615,1.615H30.522a1.614,1.614,0,0,0,1.615-1.615V17.661a1.615,1.615,0,0,0-1.615-1.615m-13.07,0a2.621,2.621,0,0,1,5.242,0,2.59,2.59,0,0,1-.127.766l-4.8.462a2.608,2.608,0,0,1-.318-1.228",
    transform: "translate(9.743 11.409)",
    fill: "#3b2a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_291",
    "data-name": "Trac\\xE9 291",
    d: "M64.787,31.165a7.152,7.152,0,0,0,.637,1.59,9.608,9.608,0,0,0,1.8,2.435,5.376,5.376,0,0,0,2.686,1.631L35.242,68.6q-2.279-2.494-4.561-4.984c-.2-.212-.393-.431-.587-.645Z",
    transform: "translate(32.529 33.687)",
    fill: "#3b2a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_292",
    "data-name": "Trac\\xE9 292",
    d: "M29.962,48.491q1.161,1.274,2.329,2.547l-3.436.866Z",
    transform: "translate(31.19 52.415)",
    fill: "#3b2a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_293",
    "data-name": "Trac\\xE9 293",
    d: "M30.858,46.448c.194.216.391.433.587.647q2.285,2.491,4.563,4.982l-.135.123-4.156,1.047c-.776-.847-1.557-1.7-2.331-2.547l1.332-4.122Z",
    transform: "translate(31.765 50.206)",
    fill: "#ffebd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_294",
    "data-name": "Trac\\xE9 294",
    d: "M52.334,31.947A4.36,4.36,0,0,1,53.5,34.53a2.7,2.7,0,0,1-.809,2.262l-.805.739A5.37,5.37,0,0,1,49.2,35.9a9.665,9.665,0,0,1-1.8-2.435,7.151,7.151,0,0,1-.637-1.59l.774-.708c1.224-1.124,3.369-.774,4.794.78",
    transform: "translate(50.549 32.977)",
    fill: "#ffebd0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagementSm);
export default __webpack_public_path__ + "static/media/project_management_sm.a172faac83d509d662f0d424f652ca06.svg";
export { ForwardRef as ReactComponent };